import React from 'react'
import Header from '../../Component/Header'
import Footer from '../../Component/Footer'
import Registration from '../Registration'

export default function LayoutRegistration() {
    return (
        <>
            <Header />
            <Registration />
            <Footer />
        </>
    )
}
